import { get } from 'lodash';
import { loading, success, error } from 'State/actions';

import * as types from './types';

export const getRecipe = recipeId => async (dispatch, getState, MPWWebApi) => {
  try {
    dispatch(loading(types.COMMON_SET_RECIPE_LOADING, true));
    const response = await MPWWebApi.getGeneric(
      `Recipe/GetRecipePreview/${recipeId}`
    );

    dispatch(success(types.COMMON_SET_RECIPE_DATA, response.data.Data));
  } catch (err) {
    const errorObj = get(err, 'response.data.Errors');

    if (errorObj) {
      dispatch(error(types.COMMON_SET_RECIPE_ERROR, errorObj));
    } else {
      dispatch(
        error(types.COMMON_SET_RECIPE_ERROR, [
          {
            Message: 'Could not load recipe.',
          },
        ])
      );
    }
  } finally {
    dispatch(loading(types.COMMON_SET_RECIPE_LOADING, false));
  }
};



// WEBPACK FOOTER //
// ./src/state/getrecipe/actions.js